/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Ledger_Kind_IntakeInputs */



/**
* | output |
* | --- |
* | "Intake" |
*
* @param {Promo_Ledger_Kind_IntakeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_ledger_kind_intake = /** @type {((inputs?: Promo_Ledger_Kind_IntakeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Ledger_Kind_IntakeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réception")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recepción")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Recebimento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ricezione")
	return /** @type {LocalizedString} */ ("Intake")
});